module.exports = __webpack_public_path__ + "static/media/pic_huang2.2021f608.png";